import { Injectable } from '@angular/core';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { FirestoreRepo } from '@repos/firestore-repo.service';
import { BusinessState } from '@state/business';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { firstValueFrom } from 'rxjs';
import { CollectionPaths } from '@models/collections';

interface MatterPackageEnvelope {
	id?: string;
}

interface EnvelopePathParams {
	packageId: string;
}

@Injectable({
	providedIn: 'root',
})
export class MatterPackageEnvelopeService extends FirestoreRepo<
	MatterPackageEnvelope,
	EnvelopePathParams
> {
	@SelectSnapshot(SelectedMatter.id) matterId: string;
	@SelectSnapshot(BusinessState.businessId) businessId: string;

	constructor() {
		super((pathParams) =>
			CollectionPaths.business_matter_package_envelopes(
				this.businessId,
				this.matterId,
				pathParams.packageId,
			),
		);
	}

	public async deleteEnvelopesForPackage(packageId: string) {
		const envelopes = await firstValueFrom(this.All({ packageId }));
		let result: Promise<void>;
		if (!envelopes?.length) {
			result = Promise.resolve();
		} else {
			const batch = this.Batch();
			envelopes.forEach((envelope) => {
				if (envelope.id) {
					batch.delete(this.DocRef(envelope.id, { packageId }));
				}
			});
			result = batch.commit();
		}
		return result;
	}
}
